import React, { Component } from "react";
import axios from "axios";
import cookie from "react-cookies";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import $ from "jquery";
import Select from "react-select";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { GET_FORMPOST, GET_DETAILDATA } from "../../../actions";
import { apiUrl, clientheaderconfig } from "../../Helpers/Config";
import {
  showLoader,
  hideLoader,
  showAlert,
  isEmpty,
  isSingleSelect,
} from "../../Helpers/SettingHelper";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
import PageLoader from "../../Helpers/PageLoader";
import Editor from "../Layout/Editor";
var module = "subcategory";
var moduleName = "Sub Categories";
var modulePath = "/clientpanel/catalog-subcategories";
var dayList = [
  { day: "Mon", checked: "No", start: "", end: "" },
  { day: "Tue", checked: "No", start: "", end: "" },
  { day: "Wed", checked: "No", start: "", end: "" },
  { day: "Thu", checked: "No", start: "", end: "" },
  { day: "Fri", checked: "No", start: "", end: "" },
  { day: "Sat", checked: "No", start: "", end: "" },
  { day: "Sun", checked: "No", start: "", end: "" },
];
class Form extends Component {
  constructor(props) {
    super(props);
    var editID = "";
    if (
      this.props.match.path ===
      "/clientpanel/catalog-subcategories/edit/:EditID"
    ) {
      editID = this.props.match.params.EditID;
    }
    var allowOutlet = cookie.load("clientAllowOutlet") ?? '';
    this.state = {
      editID: editID,
      pageloading: false,
      clientdata: {
        categoryID: "",
        subCategoryOutletID:[],
        subCategoryAvailabilityID: [],
        subCategoryName: "",        
        subCategorySequence: "",
        subCategoryShortDescription: "",
        subCategoryLongDescription: "",
        subCategoryStatus: "",
        subCategoryLeadTime: "",
        subCategoryTimeAvailability: dayList,
        action: "add",
      },
      loading: true,
      tatList: [],
      availabiltyList: [],
      outlet_availability: [],
      formpost: [],
      companyDetail: [],
      categoryList: [],
      outletList: [],
      allowOutlet: allowOutlet,
    };
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    this.loadOutlet();
    this.loadAvailabilty();
    this.loadCategory();

    if (this.state.editID !== "") {
      var params = {
        params:'' ,
        url: `${apiUrl}${module}/detail/${this.state.editID}`,
        type: "client",
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.state.formpost !== nextProps.formpost &&
      this.props.formpost !== nextProps.formpost
    ) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          var history = this.props.history;
          setTimeout(function () {
            history.push(modulePath);
          }, 1000);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (
      this.state.companyDetail !== nextProps.detaildata &&
      this.state.editID !== ""
    ) {
      this.setState({ companyDetail: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          var result = nextProps.detaildata[0].result;

          var subCategoryStatus = result.subCategoryStatus === "A" ? "Active" : "In Active";
          var status =
            result.subCategoryStatus !== "" &&
            result.subCategoryStatus !== null
              ? {
                  label: subCategoryStatus,
                  value: result.subCategoryStatus,
                }
              : "";
          var updsubCategoryTimeAvailability = [];
          if (result.subCategoryTimeAvailability!=="" && result.subCategoryTimeAvailability!==null) {
            updsubCategoryTimeAvailability = JSON.parse(result.subCategoryTimeAvailability);
          } else {
            updsubCategoryTimeAvailability = dayList;
          }

          var clientupdatedata = {
            categoryID: result?.categoryID ?? '',
            subCategoryOutletID: result?.subCategoryOutletID ?? [],
            subCategoryAvailabilityID: result?.subCategoryAvailabilityID ?? [],
            subCategoryName: result.subCategoryName,            
            subCategorySequence: result.subCategorySequence,
            subCategoryShortDescription: (result.subCategoryShortDescription!==null && result.subCategoryShortDescription!=="")?result.subCategoryShortDescription:'',    
            subCategoryLongDescription: (result.subCategoryLongDescription!=="" && result.subCategoryLongDescription!==null)?result.subCategoryLongDescription:'',            
            subCategoryLeadTime: result.subCategoryLeadTime,
            subCategoryTimeAvailability: updsubCategoryTimeAvailability,
            subCategoryStatus: status,
            action: "edit",
          };
          this.setState({ clientdata: clientupdatedata, pageloading: false });
        } else {
          this.setState({ pageloading: false });
          this.props.history.push(modulePath);
          showAlert("Error", "Invalid" + moduleName, "error");
        }
      });
    }
  }
  loadCategory() {
    var urlShringTxt = apiUrl + "category/dropDownList" ;
    axios.get(urlShringTxt, clientheaderconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ categoryList: res.data.result });
      }
    }).catch((e) => {
      console.log(e)
    });
  }

  loadOutlet() {
    var urlShringTxt = apiUrl + "outlet/dropDownList" ;
    axios.get(urlShringTxt, clientheaderconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ outletList: res.data.result });
      }
    }).catch((e) => {
      console.log(e)
    });
  }
  loadAvailabilty() {
    var urlShringTxt = apiUrl + "availability/companydropDownList";
    axios.get(urlShringTxt, clientheaderconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ availabiltyList: res.data.result });
      }
    }).catch((e) => {
      console.log(e)
    });
  }

  sateValChange = (field, value) => {
    if (field === "page") {
    }
  };

  handleChange(checked, name) {
    this.setState({ checked });
  }

  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(
      update(this.state, { clientdata: { [field]: { $set: value } } }));
  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    var postData = this.state.clientdata;

    let subCategoryOutletID = postData.subCategoryOutletID.length > 0 ? postData.subCategoryOutletID.map(item => item.value) : [];
    let subCategoryAvailabilityID = postData.subCategoryAvailabilityID.length > 0 ? postData.subCategoryAvailabilityID.map(item => item.value) : [];

    var postObject = {
      categoryID: postData.categoryID?.value ?? "",
      subCategoryOutletID:subCategoryOutletID.length > 0 ? subCategoryOutletID.join(",") : "",
      subCategoryAvailabilityID:subCategoryAvailabilityID.length > 0 ? subCategoryAvailabilityID.join(",") : "",
      subCategoryName: postData.subCategoryName,
      subCategorySequence: postData.subCategorySequence,
      subCategoryShortDescription:postData.subCategoryShortDescription,
      subCategoryLongDescription: postData.subCategoryLongDescription,
      subCategoryLeadTime: postData.subCategoryLeadTime,
      subCategoryTimeAvailability: JSON.stringify(postData.subCategoryTimeAvailability),
      subCategoryStatus:postData.subCategoryStatus?.value ?? "A",
    };

    var post_url = module;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${this.state.editID}`;
      method = 'update';
    }
    this.props.getFormPost(postObject, post_url, "client", method);
  };

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={"catalog-subcategories"} />
          <div className="layout-page">
            <Topmenu />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-10 col-md-6">
                    <h4 className="fw-bold">
                      {this.state.editID !== "" ? "Update" : "Add New"}{" "}
                      {moduleName}
                    </h4>
                  </div>
                  <div className="col-lg-2 col-md-6 text-end">
                    <Link to={modulePath}>
                      <button
                        type="button"
                        className="btn btn-outline-primary waves-effect"
                      >
                        Back
                      </button>
                    </Link>
                  </div>
                </div>
                <PostForm
                  {...this.props}
                  fields={this.state.clientdata}
                  onChange={this.fieldChange}
                  onValid={this.handleSubmit}
                  error_msg={this.state.error_msg}
                  categoryList={this.state.categoryList}
                  outletList={this.state.outletList}
                  availabiltyList={this.state.availabiltyList}
                  allowOutlet={this.state.allowOutlet}
                  onInvalid={() => {
                    console.log("Form invalid!");
                    setTimeout(function () {
                      if ($("#modulefrm .is-invalid").length > 0) {
                        $("html, body").animate(
                          {
                            scrollTop:
                              $(document)
                                .find("#modulefrm .is-invalid:first")
                                .offset().top - 200,
                          },
                          500
                        );
                      }
                    }, 500);
                  }}
                />
              </div>

              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>

        <div className="drag-target"></div>
        <PageLoader pageloading={this.state.pageloading} />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, authType, method) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, authType, method });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(Form);

function validationConfig(props) {
  const { subCategoryOutletID, categoryID, subCategoryName, subCategoryStatus } = props.fields;

  return {
    fields: ["subCategoryOutletID", "categoryID", "subCategoryName", "subCategoryStatus"],

    validations: {
      subCategoryOutletID: [[isSingleSelect, subCategoryOutletID]],
      categoryID: [[isSingleSelect, categoryID]],
      subCategoryName: [[isEmpty, subCategoryName]],
      subCategoryStatus: [[isSingleSelect, subCategoryStatus]],
    },
  };
}

class PostForm extends Component {
  constructor(props) {
    super(props);
    this.setContent = this.setContent.bind(this);
    this.setLongContent = this.setLongContent.bind(this);
  }

  handleChange(name, value) {
    this.props.onChange(name, value);
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }

  setContent(value) {
    this.props.onChange("subCategoryShortDescription", value);
  }
  setLongContent(value) {
    this.props.onChange("subCategoryLongDescription", value);
  }

  handleChangeAvailDate(dayIndex, elementType, selectDate) {
    this.updateDayAvail(dayIndex, elementType, selectDate);
  }
  handleChangeCheck(dayIndex, elementType, event) {
    var value = event.target.checked === true ? "Yes" : "No";
    this.updateDayAvail(dayIndex, elementType, value);
  }
  updateDayAvail(dayIndex, elementType, value) {
    var subCategoryTimeAvailability = this.props.fields.subCategoryTimeAvailability;
    var updsubCategoryTimeAvailability = [];
    subCategoryTimeAvailability.map((item, index) => {
      if (index === dayIndex) {
        var start = item.start;
        var end = item.end;
        var checked = item.checked;
        if (elementType === "start") {
          start = value;
        } else if (elementType === "end") {
          end = value;
        } else if (elementType === "checked") {
          checked = value;
          start = "";
          end = "";
        }
        updsubCategoryTimeAvailability.push({
          day: item.day,
          checked: checked,
          start: start,
          end: end,
        });
      } else {
        updsubCategoryTimeAvailability.push(item);
      }
      return "";
    });
    this.props.onChange("subCategoryTimeAvailability", updsubCategoryTimeAvailability);
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } =
      this.props;
    let errMsgOutlet,
      errMsgCategory,
      errMsgSubCatName,
      errMsgStatus = "";
    if ($validation.subCategoryOutletID.error.reason !== undefined) {
      errMsgOutlet = $validation.subCategoryOutletID.show && (
        <span className="error">{$validation.subCategoryOutletID.error.reason}</span>
      );
    }
    if ($validation.categoryID.error.reason !== undefined) {
      errMsgCategory = $validation.categoryID.show && (
        <span className="error">{$validation.categoryID.error.reason}</span>
      );
    }
    if ($validation.subCategoryName.error.reason !== undefined) {
      errMsgSubCatName = $validation.subCategoryName.show && (
        <span className="error">{$validation.subCategoryName.error.reason}</span>
      );
    }
    if ($validation.subCategoryStatus.error.reason !== undefined) {
      errMsgStatus = $validation.subCategoryStatus.show && (
        <span className="error">{$validation.subCategoryStatus.error.reason}</span>
      );
    }

    return (
      <form className="card fv-plugins-bootstrap5" id="modulefrm">
        <div className="card-body row g-3 mt-4">
          {this.props.allowOutlet === "" && (
            <div
              className={
                errMsgOutlet !== "" &&
                errMsgOutlet !== false &&
                errMsgOutlet !== undefined
                  ? "col-md-6 error-select error"
                  : "col-md-6"
              }
            >
              <div className="form-floating form-floating-outline custm-select-box mb-4">
                <Select
                  value={fields.subCategoryOutletID}
                  onChange={this.handleSelectChange.bind(this, "subCategoryOutletID")}
                  placeholder={"Select Outlet"}
                  options={this.props.outletList}
                  isClearable={true}
                  isMulti
                />
                <label className="select-box-label">
                  Outlet<span className="error">*</span>
                </label>
                {errMsgOutlet}
              </div>
            </div>
          )}
          <div
            className={
              errMsgCategory !== "" &&
              errMsgCategory !== false &&
              errMsgCategory !== undefined
                ? "col-md-6 error-select error"
                : "col-md-6"
            }
          >
            <div className="form-floating form-floating-outline custm-select-box">
              <Select
                value={fields.categoryID}
                onChange={this.handleSelectChange.bind(this, "categoryID")}
                placeholder={"Select Category"}
                options={this.props.categoryList}
                isClearable={true}
              />
              <label className="select-box-label">
                Category<span className="error">*</span>
              </label>
              {errMsgCategory}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline custm-select-box mb-4">
              <Select
                value={fields.subCategoryAvailabilityID}
                onChange={this.handleSelectChange.bind(
                  this,
                  "subCategoryAvailabilityID"
                )}
                isMulti
                placeholder="Select Availabilty"
                options={this.props.availabiltyList}
                isClearable={true}
              />
              <label className="select-box-label">Availabilty</label>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className={
                  errMsgSubCatName !== "" &&
                  errMsgSubCatName !== false &&
                  errMsgSubCatName !== undefined
                    ? "form-control is-invalid"
                    : "form-control"
                }
                name="subCategoryName"
                value={fields.subCategoryName}
                {...$field("subCategoryName", (e) =>
                  onChange("subCategoryName", e.target.value)
                )}
              />
              <label htmlFor="subCategoryName">
                Subcategory Name <span className="error">*</span>
              </label>
              {errMsgSubCatName}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className="form-control"
                name="subCategorySequence"
                value={fields.subCategorySequence}
                id="subCategorySequence"
                {...$field("subCategorySequence", (e) =>
                  onChange("subCategorySequence", e.target.value)
                )}
              />
              <label htmlFor="subCategorySequence">Sequence</label>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className="form-control"
                name="subCategoryLeadTime"
                value={fields.subCategoryLeadTime}
                {...$field("subCategoryLeadTime", (e) =>
                  onChange("subCategoryLeadTime", e.target.value)
                )}
              />
              <label htmlFor="subCategoryLeadTime">Lead Time</label>
            </div>
          </div>

          <div
            className={
              errMsgStatus !== "" &&
              errMsgStatus !== false &&
              errMsgStatus !== undefined
                ? "col-md-6 error-select error"
                : "col-md-6"
            }
          >
            <div className="form-floating form-floating-outline custm-select-box mb-4">
              <Select
                value={fields.subCategoryStatus}
                onChange={this.handleSelectChange.bind(this, "subCategoryStatus")}
                placeholder="Select Status"
                options={[
                  { value: "A", label: "Active" },
                  { value: "I", label: "In Active" },
                ]}
                isClearable={true}
              />
              <label className="select-box-label">
                Status<span className="error">*</span>
              </label>
              {errMsgStatus}
            </div>
          </div>
          <div className="col-md-12">
            <label>Short Description</label>
            <Editor setContent={this.setContent} data={fields.subCategoryShortDescription} />
          </div>
          <div className="col-md-12">
            <label>Long Description</label>
            <Editor setContent={this.setLongContent} data={fields.subCategoryLongDescription} />
          </div>

          <h1 className="display-6 mb-0">Time Availability</h1>
          {fields.subCategoryTimeAvailability.map((item, index) => {
            return (
              <div className="row" key={index}>
                <div className="col-md-1">
                  <div className="form-check form-check-inline mt-3">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="low_stock_alert"
                      checked={item.checked === "Yes" ? true : false}
                      onChange={this.handleChangeCheck.bind(
                        this,
                        index,
                        "checked"
                      )}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="low_stock_alert"
                    >
                      {item.day}
                    </label>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-floating-outline mt-2 custm-date-box">
                    <DatePicker
                      className="form-control"
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={15}
                      timeCaption="Time"
                      dateFormat="h:mm aa"
                      selected={
                        item.start !== "" && item.start !== null
                          ? new Date(item.start)
                          : ""
                      }
                      onChange={this.handleChangeAvailDate.bind(
                        this,
                        index,
                        "start"
                      )}
                      disabled={item.checked === "Yes" ? false : true}
                    />
                    <label className="select-box-label">From</label>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-floating-outline mt-2 custm-date-box">
                    <DatePicker
                      className="form-control"
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={15}
                      timeCaption="Time"
                      dateFormat="h:mm aa"
                      selected={
                        item.end !== "" && item.end !== null
                          ? new Date(item.end)
                          : ""
                      }
                      onChange={this.handleChangeAvailDate.bind(
                        this,
                        index,
                        "end"
                      )}
                      disabled={item.checked === "Yes" ? false : true}
                    />
                    <label className="select-box-label">To</label>
                  </div>
                </div>
              </div>
            );
          })}

          <div className="pt-1 pb-4 pt-1 text-end">
            <button
              type="button"
              className="btn btn-primary me-sm-3 me-1 waves-effect waves-light submit_frm"
              onClick={(e) => {
                e.preventDefault();
                this.props.$submit(onValid, onInvalid);
              }}
            >
              Submit
            </button>
            <Link to={"/clientpanel/outlet"}>
              <button
                type="reset"
                className="btn btn-label-secondary waves-effect"
              >
                Cancel
              </button>
            </Link>
          </div>
        </div>
      </form>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
